export default __webpack_public_path__ + "39790df5bf342dbd90572f572fe6da84.png";